import type { GridInterface } from '@ad-lucy/context/adData';
import { LoggerService } from '@ad-lucy/utils';

import { gridNameList } from './constants';
import type { GridCombinedList } from './types';

const logger = LoggerService.getLogger().getModuleLogger('getGridByCodeOrId');

/**
 * Get a GridInterface object by its code or ID definition from the backend.
 * The objects are defined in "../definitions".
 *
 * This function first tries to find a grid by the provided code or ID in the grid map.
 * The grid map should be a combined map that includes both grid codes and IDs.
 *
 * @param grids A grid list to draw the grids from (usually provided from Creatives Config).
 * @param gridId The ID of the grid to retrieve.
 * @param gridCode The code of the grid to retrieve.
 */
export const getGridByCodeOrId = (
  grids: GridCombinedList,
  gridId: string | null | undefined,
  gridCode: string | null | undefined,
): GridInterface[] => {
  const gridValue = (gridCode || gridId) as string;
  const grid = grids[gridValue];

  if (grid) {
    return grid;
  }

  logger.error(`Unsupported grid code/ID ${gridValue}, defaulting to grid 1:0.`);
  return gridNameList['1:0'];
};
